<template>
  <div id="app">
    <v-app app>
      <div id="headerMessagerie">
        <div class="divRetour">
          <a :href="'#/conversation/liste?token='+ token" title="Retour à la liste des conversations"><i
              class="mdi mdi-arrow-left-circle"></i></a>
        </div>
        <h2 class="titre">{{ titre }}</h2>
      </div>
      <v-container id="divConversationChat" class="fill-height">
        <v-dialog v-model="dialog_captcha" max-width="400">
          <v-card>
            <v-card-title class="text-h5">
              Merci de valider le captcha
            </v-card-title>
            <v-card-text>
              <VueRecaptcha ref="recaptcha1" :sitekey="cle" :load-recaptcha-script="true" @verify="handleSuccess"
                @error="handleError" @expired="onCaptchaExpired" />
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-row class="fill-height conversation-chat" align="end">
          <v-col>
            <div v-for="(message, index) in messages" :key="index"
              :class="['d-flex flex-row align-center my-2', message.auteur != 'Firsi' ? 'justify-end': null]">
              <span v-if="message.auteur != 'Firsi'" class="blue--text mr-3 chat-message chat-message-backoffice">
                <div class="chat-date">{{ message.date }}</div>
                <div>{{ message.message }}</div>
                <div>
                  <a target="_blank" rel="noopener noreferrer" :href="message.urlFichier"
                    title='Pièce jointe'>{{message.nomFichier}}</a>
                </div>
              </span>
              <v-avatar :color="message.auteur != 'Firsi' ? '#0c2251': '#d46b2b'" size="36" :title="message.auteur">
                <span class="white--text">{{ message.auteurInitiale }}</span>
              </v-avatar>
              <span v-if="message.auteur == 'Firsi'" class="blue--text ml-3 chat-message chat-message-backoffice">
                <div class="chat-date">{{ message.date }}</div>
                <div>{{ message.message }}</div>
                <div>
                  <a target="_blank" rel="noopener noreferrer" :href=message.urlFichier
                    title='Pièce jointe'>{{message.nomFichier}}</a>
                </div>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-footer fixed>
        <v-container class="ma-0 pa-0 saisie-message">
          <v-row no-gutters v-if="!envoiEnCours">
            <v-col>
              <v-row class="d-flex flex-row align-center">
                <v-col cols="2">
                  <v-file-input @change="selectFile" accept="image/jpg, image/jpeg, image/png, application/pdf"
                    label="Choisir un fichier (pdf, jpg, jpeg, png)" :show-size="1000" :rules="rules">
                  </v-file-input>
                </v-col>
                <v-col cols="10" class="d-flex flex-row align-center">
                  <v-text-field v-model="message" ref="inputmessage" placeholder="Votre message"
                    @keypress.enter="ouvrirDialog"></v-text-field>
                  <v-btn icon class="ml-4" @click="ouvrirDialog"><v-icon>mdi-send</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div v-else><img src="@/assets/waiting.gif" /> Envoi en cours</div>
          <!--Message d'erreur si le cas se présente-->
          <div id="divErreur">
            {{this.erreur}}
          </div>
        </v-container>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components:{
    VueRecaptcha,
  },
  props: {
      messages: Array,
      nomClient : String,
      initialesClient : String,
      titre : String,
      token : String,
      idConversation : String,
  },
  data() {
    return {
      dialog_captcha:false,
      cle: process.env.VUE_APP_CAPTCHA,
      rules: [
      value => !value || value.size < 3000000 || 'La taille du fichier ne doit pas dépasser 3 MB !',
      value => !value || value.type =='application/pdf' || value.type == 'image/jpeg' || value.type == 'image/jpg' || value.type == 'image/png' || 'Le type du fichier non pris en charge !',
    ],
        erreur: null,
        message: null,
        envoiEnCours: false,
        body: {
            idConversation: null,
            message: null,
            file: {
              nomFichier: null,
              typeFichier: null,
              donneePieceJointe: null,
              tailleFichier : 0,
            }
        }
    }
  },
  mounted() {
    window.scrollTo(0,document.getElementById("divConversationChat").scrollHeight);
    this.$refs.inputmessage.focus();
  },
  methods: {
    ouvrirDialog(){
      if (this.message != undefined && this.message != null && this.message != '' && this.validateFile(this.body.file)) {
        this.dialog_captcha = true;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha1.reset();
    },
    handleSuccess() {
      this.$refs.recaptcha1.reset();
      this.dialog_captcha = false;
      this.envoyerMessage();
    },
    handleError() {
      this.$refs.recaptcha1.reset();
    },
    selectFile(file) {
            if (file) {
                this.body.file.nomFichier = file.name;
                this.body.file.typeFichier = file.type;
                this.readFile(file, this.body.file);
                this.body.file.tailleFichier = file.size;
            }
            else {
                this.body.file.nomFichier = null;
                this.body.file.typeFichier = null;
                this.body.file.tailleFichier = null;
                this.body.file.donneePieceJointe = null;
            }
        },
        // Lire le contenu d'un fichier la data de l'élément en cours
        readFile(file, monFichier) {
            var reader = new FileReader();

            // Listener de fin de lecture
            reader.onloadend = function () {
                // Recupérer la chaine lise dans le data de l'élément en cours
                monFichier.donneePieceJointe = btoa(reader.result);
            }

            // Lancer la lecture du ficheir
            reader.readAsBinaryString(file);
        },

        validateFile(file){
          return file.donneePieceJointe == null ||
          (file.tailleFichier > 0 && file.tailleFichier < 3000000 && 
          (file.typeFichier == 'application/pdf' || file.typeFichier == 'image/jpeg' || file.typeFichier == 'image/jpg' || file.typeFichier == 'image/png'))
        },
    envoyerMessage: function(){
      if (this.message != undefined && this.message != null && this.message != '' && this.validateFile(this.body.file)){

        //const url = process.env.VUE_APP_BASE_API_URL + "/messagerie/envoyer/message";
        
        this.body.idConversation = this.idConversation;
        this.body.message = this.message;
        this.envoiEnCours = true;
        
        this.$storeContact.EnvoyerMessage(this.token, this.body)
        .then(response => {
          this.envoiEnCours = false;
          this.body.file.nomFichier = null;
          this.body.file.typeFichier = null;
          this.body.file.donneePieceJointe = null;
          this.body.file.tailleFichier= 0;
          
          if (response.status == 200) {

            this.message = null;
            this.messages.push(response.data);

            this.$nextTick(() => {
              window.scrollTo(0,document.getElementById("divConversationChat").scrollHeight);
            });
          }
          else {
            this.erreur = "Echec de l'envoi du message.";
          }
        })
        .catch(error => {
          this.erreur = "Echec de l'envoi du message.";
          console.log(error);
        });
      }
    }
  }
};
</script>